import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";

export const FAQ = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(0);

  return (
    <section className="py-24 lg:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="mb-12">
          <div className="eyebrow mb-3">{t.faq.eyebrow}</div>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">{t.faq.title}</h2>
        </div>

        <div className="space-y-2">
          {t.faq.list.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`glass rounded-xl overflow-hidden transition-colors ${isOpen ? "border-white/25" : ""}`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-center justify-between text-left px-6 py-5 gap-4 hover:bg-white/[0.02]"
                >
                  <span className="text-white font-semibold text-base sm:text-lg">{f.q}</span>
                  <ChevronDown size={18} className={`text-slate-400 shrink-0 transition-transform ${isOpen ? "rotate-180 text-cyan-300" : ""}`} />
                </button>
                <div
                  className={`grid transition-all ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                  aria-hidden={!isOpen}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-5 text-slate-300 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
